// Webrtc plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { combineActions, handleActions } from 'redux-actions'
import { concat, remove } from 'lodash/fp'

// Top-tier reducers: Handles the whole state.
const reducers = {}

// Add the new media object to state.
reducers[actionTypes.MEDIA_NEW] = {
  next (state, action) {
    return concat(state, {
      ...action.payload
    })
  }
}

// Remove the media object from state.
reducers[actionTypes.MEDIA_REMOVED] = {
  next (state, action) {
    const removeMedia = media => media.id === action.payload.id
    return remove(removeMedia)(state)
  }
}

// Media-tier reducers: Handles only a specific portion of the substate.
const mediaReducers = {}

mediaReducers[actionTypes.MEDIA_NEW_TRACK] = {
  next (state, action) {
    return {
      ...state,
      tracks: concat(state.tracks, [action.payload.trackId])
    }
  }
}

// Remove specified track from media state.
mediaReducers[actionTypes.MEDIA_TRACK_ENDED] = {
  next (state, action) {
    const removeTrack = trackId => trackId === action.payload.trackId
    return {
      ...state,
      tracks: remove(removeTrack, state.tracks)
    }
  }
}
const mediaReducer = handleActions(mediaReducers, {})

const specificMediaActions = combineActions(actionTypes.MEDIA_NEW_TRACK, actionTypes.MEDIA_TRACK_ENDED)

reducers[specificMediaActions] = (state, action) => {
  return state.map(media => {
    if (media.id === action.payload.id) {
      return mediaReducer(media, action)
    } else {
      return media
    }
  })
}

/*
 * Combine all of top-tier reducers into a single reducer,
 *      each with a default state of an empty array.
 */
const reducer = handleActions(reducers, [])
export default reducer
